import { NON_BREAKING_SPACE } from '../constants/constants';
import { ALL_SET_BET_ACTION_PROPERTIES } from '../scenes/poker/controls/pixi/setBetButton';
import { ALL_SIMPLE_BET_BUTTON_LABELS } from '../scenes/poker/controls/simpleBetUtils';
import { ACTIVE_TIMER_USERNAME_BACKGROUND_TEXT_STYLE, ACTIVE_TIMER_USERNAME_FOREGROUND_TEXT_STYLE, DIMMED_USERNAME_FOREGROUND_TEXT_STYLE, INACTIVE_TIMER_USERNAME_FOREGROUND_TEXT_STYLE, INACTIVE_USERNAME_BACKGROUND_TEXT_STYLE } from '../scenes/poker/player/usernameTextStyles';
import { DISCARD_ONE_TEXT, FOLDED_TEXT, LEADER_TEXT, REVEAL_ON_TEXT, REVEAL_TEXT } from '../stringConstants';
import { ACTIVE_PLAYER_CHIPS_TEXT_STYLE, ALL_IN_TEXT_STYLE, AUTO_BET_BUTTON_LABEL_TEXT_STYLE, BET_BUTTON_LABEL_TEXT_STYLE, BET_BUTTON_SUB_LABEL_TEXT_STYLE, CHIP_LEADER_TEXT_STYLE, DISCARD_ONE_TEXT_STYLE, ENABLED_AUTO_BET_BUTTON_LABEL_TEXT_STYLE, FOLDED_HOLE_CARDS_TEXT_STYLE, INACTIVE_STATUS_TEXT_STYLE, JACKS_POT_AMOUNT_TEXT_STYLE, PLAYER_BUBBLE_CARD_RANK_TEXT_STYLE, PLAYER_JACKS_SUBTLE_TEXT_STYLE, PLAYER_JACKS_TEXT_STYLE, POT_AMOUNT_TEXT_STYLE, POT_LABEL_TEXT_STYLE, REVEALING_HOLE_CARDS_TEXT_STYLE, SET_BET_BUTTON_LABEL_TEXT_STYLE, SIDE_BET_BUTTON_LABEL_TEXT_STYLE, SIDE_BET_BUTTON_SUB_LABEL_TEXT_STYLE, SIDE_BET_NAME_ANIMATION_TEXT_STYLE, SIMPLE_BET_BUTTON_LABEL_TEXT_STYLE, WINNING_HAND_NAME_TEXT_STYLE, WINNING_HAND_SUB_NAME_TEXT_STYLE } from '../styles/pixiStyles';
import { ALL_MAGNITUDE_SUFFIXES } from '../utils/numberPrecisionUtils';
import { CARD_RANK_LABELS } from './cardTypes';
import { ALL_BET_POT_LABELS, ALL_CENTER_POT_LABELS } from './pokerTypes';
export const ALL_BITMAP_TEXT_STYLE_TYPES = [
    'active-timer-foreground-text',
    'active-timer-background-text',
    'inactive-timer-foreground-text',
    'inactive-username-background-text',
    'dimmed-username-foreground-text',
    'active-player-chips',
    'inactive-player-chips-or-status',
    'active-player-jacks',
    'inactive-player-jacks',
    'all-in',
    'chips-pot-amount',
    'jacks-pot-amount',
    'pot-label',
    'button-label',
    'button-sub-label',
    'set-bet-button-label',
    'auto-bet-button-label',
    'enabled-auto-bet-button-label',
    'simple-bet-button-label',
    'folded-hole-cards',
    'reveal-overlay',
    'chip-leader',
    'discard-one',
    'winning-hand-name',
    'winning-hand-sub-name',
    'player-bubble-card-rank',
    'side-bet-button-label',
    'side-bet-button-sub-label',
    'side-bet-name-animation'
];
/**
 * Lower-case 'b' is used for 'bb' big blind multiple suffix.
 */
const CHIP_AMOUNT_CHARS = ` 0123456789,.MAX${ALL_MAGNITUDE_SUFFIXES.join('')}b`;
const WINNING_HAND_NAME_CHARS = ' ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!';
const USERNAME_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_';
const TIMER_CHARS = [
    // add username / general text chars:
    USERNAME_CHARS,
    ' ',
    // add ellipsis when text is truncated:
    '…'
];
export const ALL_BITMAP_TEXT_STYLE_PROPERTIES = {
    'active-timer-foreground-text': {
        textStyle: ACTIVE_TIMER_USERNAME_FOREGROUND_TEXT_STYLE,
        chars: TIMER_CHARS,
        heightAdjustmentPx: -4
    },
    'active-timer-background-text': {
        textStyle: ACTIVE_TIMER_USERNAME_BACKGROUND_TEXT_STYLE,
        chars: TIMER_CHARS,
        heightAdjustmentPx: -4
    },
    'inactive-timer-foreground-text': {
        textStyle: INACTIVE_TIMER_USERNAME_FOREGROUND_TEXT_STYLE,
        chars: TIMER_CHARS
    },
    'inactive-username-background-text': {
        textStyle: INACTIVE_USERNAME_BACKGROUND_TEXT_STYLE,
        chars: TIMER_CHARS
    },
    'dimmed-username-foreground-text': {
        textStyle: DIMMED_USERNAME_FOREGROUND_TEXT_STYLE,
        chars: TIMER_CHARS
    },
    'active-player-chips': { textStyle: ACTIVE_PLAYER_CHIPS_TEXT_STYLE, chars: CHIP_AMOUNT_CHARS },
    'inactive-player-chips-or-status': {
        textStyle: INACTIVE_STATUS_TEXT_STYLE,
        chars: `${CHIP_AMOUNT_CHARS}SitOutStand`
    },
    'active-player-jacks': { textStyle: PLAYER_JACKS_TEXT_STYLE, chars: CHIP_AMOUNT_CHARS },
    'inactive-player-jacks': { textStyle: PLAYER_JACKS_SUBTLE_TEXT_STYLE, chars: CHIP_AMOUNT_CHARS },
    'all-in': { textStyle: ALL_IN_TEXT_STYLE, chars: 'ALL-IN' },
    'chips-pot-amount': { textStyle: POT_AMOUNT_TEXT_STYLE, chars: CHIP_AMOUNT_CHARS, heightAdjustmentPx: -4 },
    'jacks-pot-amount': { textStyle: JACKS_POT_AMOUNT_TEXT_STYLE, chars: CHIP_AMOUNT_CHARS, heightAdjustmentPx: -4 },
    'pot-label': {
        textStyle: POT_LABEL_TEXT_STYLE,
        chars: [...ALL_CENTER_POT_LABELS, ...ALL_BET_POT_LABELS]
    },
    'button-label': {
        textStyle: BET_BUTTON_LABEL_TEXT_STYLE,
        chars: [' ABCDEFGHIJKLMNOPQRSTUVWXYZ-', '+—']
    },
    'button-sub-label': {
        textStyle: BET_BUTTON_SUB_LABEL_TEXT_STYLE,
        chars: CHIP_AMOUNT_CHARS
    },
    'set-bet-button-label': {
        textStyle: SET_BET_BUTTON_LABEL_TEXT_STYLE,
        chars: Object.values(ALL_SET_BET_ACTION_PROPERTIES).map(({ label }) => label)
    },
    'auto-bet-button-label': {
        textStyle: AUTO_BET_BUTTON_LABEL_TEXT_STYLE,
        chars: ['FOLD ANY', 'CHECK']
    },
    'enabled-auto-bet-button-label': {
        textStyle: ENABLED_AUTO_BET_BUTTON_LABEL_TEXT_STYLE,
        chars: [`✓${NON_BREAKING_SPACE}`, 'FOLD ANY', 'CHECK']
    },
    'simple-bet-button-label': {
        textStyle: SIMPLE_BET_BUTTON_LABEL_TEXT_STYLE,
        chars: ALL_SIMPLE_BET_BUTTON_LABELS
    },
    'folded-hole-cards': {
        textStyle: FOLDED_HOLE_CARDS_TEXT_STYLE,
        chars: FOLDED_TEXT
    },
    'reveal-overlay': {
        textStyle: REVEALING_HOLE_CARDS_TEXT_STYLE,
        chars: [REVEAL_TEXT, REVEAL_ON_TEXT]
    },
    'chip-leader': { textStyle: CHIP_LEADER_TEXT_STYLE, chars: LEADER_TEXT },
    'discard-one': {
        textStyle: DISCARD_ONE_TEXT_STYLE,
        chars: DISCARD_ONE_TEXT
    },
    'winning-hand-name': {
        textStyle: WINNING_HAND_NAME_TEXT_STYLE,
        chars: WINNING_HAND_NAME_CHARS
    },
    'winning-hand-sub-name': {
        textStyle: WINNING_HAND_SUB_NAME_TEXT_STYLE,
        chars: WINNING_HAND_NAME_CHARS
    },
    'player-bubble-card-rank': {
        textStyle: PLAYER_BUBBLE_CARD_RANK_TEXT_STYLE,
        chars: Object.values(CARD_RANK_LABELS)
    },
    'side-bet-button-label': {
        textStyle: SIDE_BET_BUTTON_LABEL_TEXT_STYLE,
        chars: ['SIDE BET', 'CANCEL']
    },
    'side-bet-button-sub-label': {
        textStyle: SIDE_BET_BUTTON_SUB_LABEL_TEXT_STYLE,
        chars: [CHIP_AMOUNT_CHARS, 'SIDE BET', 'JACKS']
    },
    'side-bet-name-animation': {
        textStyle: SIDE_BET_NAME_ANIMATION_TEXT_STYLE,
        chars: USERNAME_CHARS
    }
};
